module.exports = __webpack_public_path__ + "469ecd63e2b785ac0cde1d7900c904d0.png";